<template>
    <div class="about-view">
        <div class="">
            <div style="height: 0.5rem; margin-bottom: 2rem;"/>
            <h1 class="mt-0">Error 404: Page Not Found</h1>
            <!-- <p>TO DO</p> -->
        </div>
    </div>
  </template>
  
  <script setup>
  </script>